import * as React from 'react';
import MUIButton from '@mui/material/Button';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { Props } from '../types';
import Loader from './Loader/Loader';
import { Add } from '../../../Icons';

const Button = React.forwardRef<HTMLButtonElement, Props>(
	(
		{
			variant = 'optionAction',
			classes,
			disabled,
			isLoading,
			children,
			endIcon,
			disableElevation = true,
			...props
		},
		ref
	) => {
		const { Button: theme } = useTheme('BaseComponents');

		const isOptionActionPlusIcon = variant === 'optionActionPlusIcon';

		return (
			<MUIButton
				ref={ref}
				classes={{
					...classes,
					root: cn(
						theme.root,
						theme[variant],
						{
							[theme.loading]: isLoading
						},
						classes?.root
					),
					disabled: cn(theme.disabled, classes?.disabled),
					endIcon: cn(theme.endIcon, classes?.endIcon),
					startIcon: cn(theme.startIcon, classes?.startIcon)
				}}
				disabled={disabled || isLoading}
				endIcon={isOptionActionPlusIcon && !isLoading ? Add : endIcon}
				disableElevation={disableElevation}
				{...props}
			>
				{isLoading ? <Loader /> : children}
			</MUIButton>
		);
	}
);

Button.displayName = 'Button';

export default Button;
